import moment from 'moment'
import React, { useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { CustomList } from '../generic'
import { ConfigHeader } from './components/ConfigHeader'
import { SystemAuditView } from './components/SystemAuditView'
import { getSystemAuditLogs } from './services/systemAudit'
import { PdfTableContainer, SystemAuditContainer } from './styles'

interface ISelectPagination {
    value: number
    label: string
}

export const SystemAudit: React.FC = () => {
    // const [inLoading, setInLoading] = useState(true)
    const [time, setTime] = useState<string | null>()
    const [startDay, setStartDay] = useState<string | null>()
    const [endDay, setEndDay] = useState<string | null>()
    const [startHour, setStartHour] = useState<string | null>()
    const [endHour, setEndHour] = useState<string | null>()
    const [systemAuditData, setSystemAuditData] = React.useState<ISystemAudit[]>()
    const [systemAuditDataToPDF, setSystemAuditDataToPDF] = React.useState<ISystemAudit[]>()
    const [isLoading, setIsLoading] = React.useState<boolean>(false)
    const [total, setTotal] = useState<number>()
    const [totalToPDF, setTotalToPDF] = useState<number>()
    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<ISelectPagination>({ label: `30 ${i18n('items')} | ${i18n('page')}`, value: 30 })
    const [filterAuthor, setFilterAuthor] = useState<ISelect>({ label: '', value: '' })
    const [filterStatus, setFilterStatus] = useState<ISelect>({ label: '', value: '' })
    const [filterHttpVerb, setFilterHttpVerb] = useState<ISelect>({ label: '', value: '' })
    const [searchString, setSearchString] = useState<string>('')

    return (
        <>
            <SystemAuditContainer>
                <ConfigHeader
                    setTime={setTime}
                    setStartDay={setStartDay}
                    setEndDay={setEndDay}
                    setStartHour={setStartHour}
                    setEndHour={setEndHour}
                    startDay={startDay}
                    endDay={endDay}
                    startHour={startHour}
                    endHour={endHour}
                    time={time}
                    setSystemAuditData={setSystemAuditData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setTotal={setTotal}
                    perPage={limit.value}
                    page={page}
                    filterAuthor={filterAuthor}
                    setFilterAuthor={setFilterAuthor}
                    filterStatus={filterStatus}
                    setFilterStatus={setFilterStatus}
                    filterHttpVerb={filterHttpVerb}
                    setFilterHttpVerb={setFilterHttpVerb}
                    searchString={searchString}
                    setSearchString={setSearchString}
                    setSystemAuditDataToPDF={setSystemAuditDataToPDF}
                />
                <SystemAuditView
                    limit={limit}
                    setLimit={setLimit}
                    total={total}
                    setTotal={setTotal}
                    page={page}
                    setPage={setPage}
                    systemAuditData={systemAuditData}
                    setSystemAuditData={setSystemAuditData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    startDay={startDay}
                    endDay={endDay}
                    startHour={startHour}
                    endHour={endHour}
                    filterAuthor={filterAuthor}
                    filterStatus={filterStatus}
                    filterHttpVerb={filterHttpVerb}
                    searchString={searchString}
                    setSearchString={setSearchString}
                />
            </SystemAuditContainer>
            {systemAuditDataToPDF && (
                <PdfTableContainer id="pdf-table-container">
                    <CustomList
                        className="export-pdf"
                        label="pdfExport"
                        list={systemAuditDataToPDF?.map((data, index) => ({
                            date: data.date,
                            description: data.commonQuestionsDto.what,
                            statusCode: data.statusCode,
                            httpVerb: data.httpVerb,
                            pluginName: data.pluginName,
                            liveAuthor: data.liveAuthor
                        }))}
                        columns={[
                            { title: 'DATE', listRef: 'date', sortable: false },
                            { title: 'DESCRIPTION', listRef: 'description', sortable: false },
                            { title: 'STATUS CODE', listRef: 'statusCode', sortable: false },
                            { title: 'HTTP VERB', listRef: 'httpVerb', sortable: false },
                            { title: 'PLUGIN NAME', listRef: 'pluginName', sortable: false },
                            { title: 'AUTHOR', listRef: 'liveAuthor', sortable: false }
                        ]}
                        onSortClick={() => console.log()}
                        sortDirection={'ASC'}
                        sortField={'date'}
                    />
                </PdfTableContainer>
            )}
        </>
    )
}
